import { Component } from '@angular/core';
import { NadaSpinnerComponent } from '../nada-spinner/nada-spinner.component';

@Component({
  selector: 'app-overlay-spinner',
  standalone: true,
  imports: [NadaSpinnerComponent],
  templateUrl: './overlay-spinner.component.html',
  styleUrl: './overlay-spinner.component.css',
})
export class OverlaySpinnerComponent {}
